import { AlertDialog, Button } from 'components';
import { useAppDispatch, useAppSelector } from 'hooks';
import React, { FC, useState } from 'react';
import { ButtonType } from 'types/enums';
import { FacilityResponseDto } from 'types/types';
import styles from './styles.module.sass';
import { facilityActions } from 'utils/store';
import { getDialogTitle } from './helpers';

export const ListItem: FC<FacilityResponseDto> = ({
  name,
  address1,
  address2,
  city,
  state,
  website,
  id,
  phone,
  zip,
}) => {
  const accountFacilities = useAppSelector(({ facility }) => facility.accountFacilities);
  const isAccountInFacility = accountFacilities?.some((facility) => facility.id === id);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onLeaveFacilityClick = async (id: string) => {
    await dispatch(facilityActions.leaveFacility(id));
    setIsDialogOpen(false);
  };

  const onCloseDialog = () => setIsDialogOpen(false);

  const openDialog = () => setIsDialogOpen(true);

  const dispatch = useAppDispatch();

  const onFacilityJoinClick = (id: string) => {
    dispatch(facilityActions.connectToFacility(id));
  };

  return (
    <div>
      <h3>{name}</h3>
      <a href={website} rel='noreferrer' target='_blank'>
        {website}
      </a>
      <address>{address1}</address>
      <address>{address2}</address>
      <p>
        {city} {state},
      </p>
      <p>{zip}</p>
      <a href='tel:{phone}'>{phone}</a>
      <div className={styles.btn_container}>
        {isAccountInFacility ? (
          <>
            <AlertDialog
              title={getDialogTitle(name)}
              isOpen={isDialogOpen}
              onCancel={onCloseDialog}
              onConfirm={() => onLeaveFacilityClick(id)}
            />
            <Button buttonType={ButtonType.SECONDARY} onClick={openDialog}>
              Leave Facility
            </Button>
          </>
        ) : (
          <Button buttonType={ButtonType.PRIMARY} onClick={() => onFacilityJoinClick(id)}>
            Join Facility
          </Button>
        )}
      </div>
    </div>
  );
};
